import api from "../../database";

export type TransactionType = "all" | "sent" | "received";
export type TransactionDirection = "sent" | "received";

export interface ITransactionItem {
  id: string;
  direction: TransactionDirection;
  name: string;
  amount: number;
  date: string;
  code: number;
}

export interface ITransactionFilters {
  type: TransactionType;
  from?: string; // YYYY-MM-DD (dia de Brasília)
  to?: string; // YYYY-MM-DD (inclusivo)
  search?: string; // nome ou código da contraparte
}

export interface IGetTransactionsResponse {
  type: TransactionType;
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  transactions: ITransactionItem[];
}

export const getTransactions = async (
  token: string,
  filters: ITransactionFilters,
  page: number = 1,
  limit: number = 20,
  signal?: AbortSignal,
): Promise<IGetTransactionsResponse> => {
  const response = await api.get("/transactions", {
    params: {
      type: filters.type,
      page,
      limit,
      from: filters.from || undefined,
      to: filters.to || undefined,
      search: filters.search || undefined,
    },
    headers: {
      "x-access-token": token,
    },
    signal,
  });

  return response.data;
};
